import api from './api';

// Client Group / Family Group spine (onboarding module — Module 1).
export const clientGroupsAPI = {
  list: () => api.get('/api/client-groups'),
  get: (groupId) => api.get(`/api/client-groups/${groupId}`),
  create: (data) => api.post('/api/client-groups', data),
  update: (groupId, data) => api.patch(`/api/client-groups/${groupId}`, data),
  remove: (groupId) => api.delete(`/api/client-groups/${groupId}`),
  addMember: (groupId, data) => api.post(`/api/client-groups/${groupId}/members`, data),
  removeMember: (groupId, clientId) => api.delete(`/api/client-groups/${groupId}/members/${clientId}`),
  backfill: () => api.post('/api/client-groups/backfill'),
};
